import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import CorporateActionEventsVM from './CorporateActionEventsVM';
import { observer } from 'mobx-react';
import Loading from '../../../App/Components/Loading/Loading';
import { TextConstants } from '../../../Common/TextConstants';
import CorporateActionEventLookup from '../Models/Lookups/CorporateActionEventLookup';
import CorporateActionEventTransactionsComponent from '../Components/CorporateActionEventTransactionsComponent';

@observer
export default class CorporateActionEventsView extends Views.ViewBase<CorporateActionEventsVM> {

    constructor(props: unknown) {
        super("Corporate Action Events", CorporateActionEventsVM, props);
    }

    public render() {
        return (
            <>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}

                {this.viewModel.displayCorporateActionEventTransactionsComponent &&
                    <>
                        <CorporateActionEventTransactionsComponent
                            viewModel={this.viewModel.corporateActionEventTransactionsComponentVM}
                            onCancel={() => this.viewModel.backToCorporateActionEvents()}
                        />
                    </>
                }

                {this.viewModel.displayCorporateActionEventParent &&
                    <Neo.Card title={TextConstants.Titles.CorporateActionEvents} className="m-1">
                        <Neo.Form model={this.viewModel.corporateActionEventSearchCriteria} onSubmit={() => this.viewModel.pageManager.refreshData()}>
                            <Neo.GridLayout md={6}>
                                <Neo.FormGroup
                                    appendText="fa-calendar"
                                    label={TextConstants.Labels.StartDate}
                                    bind={this.viewModel.corporateActionEventSearchCriteria.meta.rangeStartDate}
                                />
                                <Neo.FormGroup
                                    appendText="fa-calendar"
                                    label={TextConstants.Labels.EndDate}
                                    bind={this.viewModel.corporateActionEventSearchCriteria.meta.rangeEndDate}
                                />
                                <Neo.FormGroup
                                    label={TextConstants.Labels.EventType}
                                    bind={this.viewModel.corporateActionEventSearchCriteria.meta.rawEventType}>
                                </Neo.FormGroup>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.CorporateActionType}
                                    bind={this.viewModel.corporateActionEventSearchCriteria.meta.rawCorporateActionType}>
                                </Neo.FormGroup>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.UnderlyingSecurityCode}
                                    bind={this.viewModel.corporateActionEventSearchCriteria.meta.rawUnderlyingSecurityCode}>
                                </Neo.FormGroup>
                            </Neo.GridLayout>
                        </Neo.Form>
                        <Neo.Pager pageManager={this.viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show:" }}>
                            <div className="horizontalScroll">
                                {this.viewModel.pageManager.totalRecords > 0 &&
                                    <NeoGrid.Grid<CorporateActionEventLookup> className={"table-striped"}>
                                        {(item, meta) => (
                                            <NeoGrid.Row key={item.corporateActionEventID}>
                                                <NeoGrid.Column display={meta.broker} />
                                                <NeoGrid.Column display={meta.instrument} />
                                                <NeoGrid.Column display={meta.dateEvent} cellClassName="text-center" />
                                                <NeoGrid.Column display={meta.rawEventType} label={TextConstants.Labels.EventType} />
                                                <NeoGrid.Column display={meta.rawCorporateActionType} label={TextConstants.Labels.CorporateActionType} />
                                                <NeoGrid.Column display={meta.rawExchange} label={TextConstants.Labels.Exchange} />
                                                <NeoGrid.Column display={meta.rawUnderlyingSecurityCode} label={TextConstants.Labels.UnderlyingSecurityCode} />
                                                <NeoGrid.Column label={TextConstants.Labels.CorporateActionReference}>
                                                    <Neo.Input bind={meta.corporateActionReference} onFocus={() => { this.viewModel.rememberCorporateActionReference(item) }} onBlur={() => { this.viewModel.updateCorporateActionReference(item) }} />
                                                </NeoGrid.Column>
                                                <NeoGrid.ButtonColumn className="text-center">
                                                    <Neo.Button
                                                        variant="primary" isOutline className="btn-small"
                                                        onClick={() => this.viewModel.showCorporateActionEventTransactionsComponent(item)}
                                                    >
                                                        <i className="fa fa-eye"></i>
                                                    </Neo.Button>
                                                </NeoGrid.ButtonColumn>
                                            </NeoGrid.Row>
                                        )}
                                    </NeoGrid.Grid>
                                }
                            </div>
                        </Neo.Pager>
                    </Neo.Card>
                }
            </>
        );
    }
}